/* eslint-disable no-underscore-dangle */
import { isServer } from '@app/utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerTraits } from '@app/redux/customer/selectors';
import { useGeoIpLocation } from '@app/user';

/**
 *
 */
const useAttachUserConfigToWindow = () => {
  const customerTraits = useSelector(getCustomerTraits);
  const geoIPLocation = useGeoIpLocation();
  useMemo(() => {
    if (isServer) {
      return;
    }

    window.__STOCKX_USER_CONFIG__ = {
      segmentGeoLocation: geoIPLocation,
      segmentCustomerTraits: customerTraits,
    };
  }, [customerTraits, geoIPLocation]);
};

export default useAttachUserConfigToWindow;
